module.exports = __webpack_public_path__ + "static/apple-podcasts-58b11df0a0b2249bcb49268e991217a2.svg";